<template>
  <div class="deviceTotal" style="height: 100%;">
    <!--设备总量-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
          style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span style="">{{ labelName }}</span>
    </div>
    <el-row style="padding-top: 20px;">
      <el-col :span="10" style="text-align: right;padding-right: 20px;">
        <el-progress class="lift" :percentage="25" :stroke-width="8" :width="75" :show-text="true"
                     color="#F95453"  type="circle" >
        </el-progress>
        <div class="text-blueGrey" style="font-size: 0.8rem;margin-top: 5px;">电梯总数: 20</div>
      </el-col>
      <el-col :span="10">
        <div style="width: 100%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 5px;margin-top: 8px;">
          <span
              style="width: 5px;height: 5px;background-color: rgba(0, 195, 211, 1);display: inline-block;border-radius: 50%;margin-right: 5px;margin-bottom: 3px;"></span>
          <span>正常数：<span id="deviceCount">15</span></span>
        </div>
        <div style="width: 100%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 5px;margin-top: 10px;">
          <span
              style="width: 5px;height: 5px;background-color: rgba(249, 84, 83, 1);display: inline-block;border-radius: 50%;margin-right: 5px;margin-bottom: 3px;"></span>
          <span>故障数：<span id="deviceAlarm">5</span></span>
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
import $ from 'jquery';
import {countDeviceStatusBySpaceAndTag} from "@/network/device-info";

export default {
  name: "ElevatorTotal",
  props: {
    labelName: {
      type: String,
      default: ""
    },
    spaceId: {
      type: String,
      default: () => null
    },
    tagId: {
      type: String,
      default: null,
    }
  },
  watch: {
    spaceId() {
      this.getData();
    },
    tagId() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    // this.$nextTick(() => {
    //   $('.deviceTotal .el-progress__text').append('<div>' + this.percentage + '</div>')
    // })
  },
  data() {
    return {
      percentage: 0,
      normal: 0,
      exception: 0
    }
  },
  methods: {
    getData() {
      countDeviceStatusBySpaceAndTag(this.spaceId, this.tagId).then(res => {
        if (res.code === 0) {
          let total = 0;
          this.normal = 0;
          this.exception = 0;
          if (res.data.length > 0) {
            res.data.forEach(item => {
              total += item.value;
              if (item.name === 'exceptionCount') {
                this.exception = item.value;
              } else if (item.name === 'normalCount') {
                this.normal = item.value;
              }
            })
            this.percentage = (this.exception / total) * 100;
          } else {
            this.percentage = 0;
          }
          $('.deviceTotal .el-progress__text').html(this.percentage.toFixed(1) + '%')
        }
      })
    }

  }
}
</script>

<style scoped>
.deviceTotal .el-progress >>> .el-progress__text {
  font-size: 1.6rem !important;
  color: #fff;
}

.lift  >>> .el-progress-circle__track {
  stroke: #308DE9!important;
}
</style>
